export { default as rules } from './rules'

export const gpsStatuses: Record<string, string> = {
  trackoftheweek: 'Track of the Week',
  surgingtrack: 'Surging Track',
  radar: 'Radar'
}
